import type { EditorElement } from '../../../editor/types';
import { getT } from '../../../locales';

export const deriveElementLabel = (element: EditorElement): string => {
  const t = getT();
  const truncateLabel = (text: string, maxLength = 28) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  if (element.type === 'text') {
    return truncateLabel((element.data as { content?: string }).content || t('elements.label.textBlock'));
  }

  if (element.type === 'audio') {
    const style = (element.data as { style?: { label?: string } }).style;
    const label = style?.label || t('elements.label.audioFile');
    return truncateLabel(label);
  }

  if (element.type === 'matching-point') {
    const data = element.data as { pointType?: 'source' | 'target'; name?: string };
    const pointType = data.pointType || 'source';
    const name = data.name?.trim();

    if (name) {
      return truncateLabel(`${pointType === 'source' ? t('elements.label.sourcePoint') : t('elements.label.targetPoint')}: ${name}`);
    }

    return pointType === 'source' ? t('elements.label.sourcePoint') : t('elements.label.targetPoint');
  }

  if (element.type === 'color-palette') {
    return t('elements.label.colorPalette');
  }

  return element.type;
};
